import React from "react";

export default function CollectionBanner({
  categoryTitle,
  bannerImage = "https://manybooks.net/sites/default/files/2018-07/bookcoverssmall2.jpg",
}) {
  return (
    <section
      style={{
        backgroundImage: `url(${bannerImage})`,
      }}
      className="relative min-h-[140px] sm:min-h-[180px] lg:min-h-[240px] flex items-center bg-cover bg-center bg-no-repeat border-b border-zinc-800/80 overflow-hidden"
    >
      {/* Immersive cinematic dark & radial overlay */}
      <div className="absolute inset-0 bg-gradient-to-t md:bg-gradient-to-r from-zinc-950 via-zinc-950/90 md:via-zinc-950/75 to-zinc-950/30 z-0" />
      <div className="absolute -top-24 -left-24 w-96 h-96 bg-secondary/10 rounded-full blur-3xl pointer-events-none z-0" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-14 py-4 sm:py-6 lg:py-8">
        <div className="max-w-2xl text-left">
          <div className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full bg-secondary/15 border border-secondary/30 text-secondary text-[10px] sm:text-xs font-extrabold uppercase tracking-widest backdrop-blur-md mb-1.5 shadow-sm">
            <span className="w-1.5 h-1.5 rounded-full bg-secondary animate-pulse" />
            <span>Curated Collection</span>
          </div>
          <h1 className="text-xl sm:text-3xl lg:text-5xl font-black tracking-tight text-white leading-tight font-outfit">
            Explore{" "}
            <span className="text-secondary capitalize font-extrabold drop-shadow-sm">
              {categoryTitle}
            </span>
          </h1>
          <p className="text-[11px] sm:text-xs md:text-sm text-zinc-400 mt-1 max-w-lg hidden sm:block">
            Discover top-rated media, exclusive subscriber originals, and curated releases.
          </p>
        </div>
      </div>
    </section>
  );
}

